import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgNotificationsNavIconSecondary from './svgs/NotificationsNavIconSecondary.js';
import SvgNotificationsNavIcon from './svgs/NotificationsNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var notificationsNavIcon = (props => useIcon(SvgNotificationsNavIcon, SvgNotificationsNavIconSecondary, props));

export { notificationsNavIcon as default };
